import moment from "moment";

const NOW = moment();

const START_OF_TODAY = NOW.clone().startOf("day");
const END_OF_TODAY = NOW.clone().endOf("day");

export const ORDER_QUERIES = {
	organization: "organization",
	name: "name",
	description: "description",
	assignedUser: "assignedUser",
	assignedTo: "assignedTo",
	assignedBy: "assignedBy",
	status: "status",
	deadline: "deadline",
	created: "created"
};

// Sort options offered in the list toolbar, in display order
export const SORT_OPTIONS = [
	{ id: ORDER_QUERIES.deadline, label: "Deadline" },
	{ id: ORDER_QUERIES.name, label: "Title" },
	{ id: ORDER_QUERIES.description, label: "Description" },
	{ id: ORDER_QUERIES.organization, label: "Organization" },
	{ id: ORDER_QUERIES.status, label: "Status" },
	{ id: ORDER_QUERIES.created, label: "Created" }
];

// Client-side grouping of the loaded rows
export const GROUP_BY_OPTIONS = [
	{ id: "none", label: "None" },
	{ id: "client", label: "Client" },
	{ id: "status", label: "Status" },
	{ id: "assignee", label: "Assignee" },
	{ id: "due", label: "Due bucket" }
];

// Quick due-date presets. Each id is a dateFunction the API understands (see WORKFLOW.dateFunctions).
export const DUE_PRESETS = [
	{ id: "all", label: "Any time", chip: "Due date" },
	{ id: "overdue", label: "Overdue", chip: "Overdue" },
	{ id: "today", label: "Today", chip: "Due today" },
	{ id: "thisWeek", label: "This week", chip: "Due this week" },
	{ id: "nextWeek", label: "Next week", chip: "Due next week" },
	{ id: "afterNextWeek", label: "After next week", chip: "Due later" },
	{ id: "noDueDate", label: "No due date", chip: "No due date" }
];

export const STATUS_ORDER = ["pending", "ready", "in_progress", "done"];

export const STATUSES = {
	pending: {
		id: "pending",
		name: "Pending",
		color: "rgba(215, 215, 215, 0.4)"
	},
	ready: {
		id: "ready",
		name: "Ready",
		color: "rgb(208, 208, 208)"
	},
	in_progress: {
		id: "in_progress",
		name: "In Progress",
		color: "rgba(255, 237, 30, 0.38)"
	},
	done: {
		id: "done",
		name: "Done",
		color: "rgba(126, 211, 33, 0.4)"
	}
};

export const DEADLINES = {
	overdue: {
		id: "overdue",
		name: "Overdue",
		color: "rgb(255 160 160 / 40%)",
		range: {
			start: END_OF_TODAY.clone().subtract(5000, "days"),
			end: END_OF_TODAY.clone().subtract(1, "days")
		}
	},
	today: {
		id: "today",
		name: "Today",
		color: "rgb(208, 208, 208)",
		range: {
			start: START_OF_TODAY.clone(),
			end: END_OF_TODAY.clone()
		}
	},
	thisWeek: {
		id: "this_week",
		name: "This Week",
		color: "rgba(255, 237, 30, 0.38)",
		range: {
			start: START_OF_TODAY.clone().weekday(0),
			end: START_OF_TODAY.clone().weekday(6)
		}
	},
	nextWeek: {
		id: "next_week",
		name: "Next Week",
		color: "rgba(126, 211, 33, 0.4)",
		range: {
			start: START_OF_TODAY.clone().weekday(6),
			end: START_OF_TODAY.clone()
				.weekday(6)
				.add(7, "days")
		}
	},
	afterNextWeek: {
		id: "after_next_week",
		name: "After Next Week",
		color: "rgba(215, 215, 215, 0.4)",
		range: {
			start: START_OF_TODAY.clone().weekday(14),
			end: START_OF_TODAY.clone()
				.weekday(14)
				.add(5000, "days")
		}
	}
};
